//------------- REACT IMPORT ---------------//
import React from "react";
//---------- FONTAWESOME IMPORT ------------//
import { faCalendar, faCheckCircle, faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Card, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import PaginationComponent from "../../CommanComponents/Pagination";

const Medicine = () => {
    return (
        <>
            <div className="medicine_tab_screen">
                <Card>
                    <Card.Body>
                        <Table responsive>
                            <tr>
                                <td className="medicine_title">Aspirin</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Ibuprofen</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Acetaminophen</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Amoxicillin</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Lipitor</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                        </Table>
                        <div className="bottom_area">
                            <div className="left_area">
                                <p>Last Update : 5 July, 2023 11:00AM</p>
                            </div>
                            <div className="right_area">
                                <p>Prescribed by : <a href="javascript:;" className="prescribed">Harry Joe</a></p>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <Table responsive>
                            <tr>
                                <td className="medicine_title">Aspirin</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger></td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Ibuprofen</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Acetaminophen</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Amoxicillin</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Lipitor</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>

                        </Table>
                        <div className="bottom_area">
                            <div className="left_area">
                                <p>Last Update : 5 July, 2023</p>
                            </div>
                            <div className="right_area">
                                <p>Prescribed by : Harry Joe</p>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <Table responsive>
                            <tr>
                                <td className="medicine_title">Aspirin</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Ibuprofen</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Acetaminophen</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Amoxicillin</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_one" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>
                            <tr>
                                <td className="medicine_title">Lipitor</td>
                                <td>
                                    <ul className="list-inline">
                                        <li>
                                            <FontAwesomeIcon icon={faCheckCircle} className="check_icon" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                        <li>
                                            <FontAwesomeIcon icon={faCircle} className="circle_icon_two" />
                                        </li>
                                    </ul>
                                </td>
                                <td className="nurse_name">Last Taken : Nurse Name</td>
                                <td className="timing">
                                    <OverlayTrigger
                                        delay={{ hide: 450, show: 300 }}
                                        overlay={(props) => (
                                            <Tooltip {...props}>
                                                5 July, 2023 11:00AM
                                            </Tooltip>
                                        )}
                                        placement="bottom"
                                    ><FontAwesomeIcon icon={faCalendar} className="tooltip_icon" />
                                    </OverlayTrigger>
                                </td>
                            </tr>

                        </Table>
                        <div className="bottom_area">
                            <div className="left_area">
                                <p>Last Update : 5 July, 2023</p>
                            </div>
                            <div className="right_area">
                                <p>Prescribed by : Harry Joe</p>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
            <PaginationComponent />
        </>
    )
}

export default Medicine;